<script>
    import loader from "../stores/loader";
</script>

<div class="loader" class:visible={$loader.visible}></div>
